import { Box, styled } from '@ltvco/refresh-lib/theme';

export const PageContainer = styled(Box)(({ theme }) => ({
  height: '98%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '16px',
  margin: '0px',
  overflow: 'auto',
  paddingBottom: 'env(safe-area-inset-bottom)',
  [theme.breakpoints.up('md')]: {
    margin: '30px 0',
    paddingBottom: 0,
  },
  [theme.breakpoints.up('lg')]: {
    margin: '8px',
  },
}));

export const MessagesArea = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  padding: '24px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  maxWidth: '800px',
  width: '100%',
  margin: '0 auto',
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  animation: 'fadeIn 0.5s ease-in-out',
});

export const MessageBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isUser',
})<{ isUser?: boolean }>(({ theme, isUser }) => ({
  maxWidth: '80%',
  padding: '12px 16px',
  borderRadius: '12px',
  alignSelf: isUser ? 'flex-end' : 'flex-start',
  backgroundColor: isUser
    ? theme.palette.primary.main
    : theme.palette.background.paper,
  color: isUser
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  boxShadow: isUser ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
  wordBreak: 'break-word',
  lineHeight: 1.5,
  fontSize: '14px',
  whiteSpace: 'pre-wrap',
}));

export const LandingContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  gap: '24px',
});

export const LandingTitle = styled('h1')(({ theme }) => ({
  fontSize: '28px',
  fontWeight: 600,
  color: theme.palette.text.primary,
  margin: 0,
  textAlign: 'center',
}));

export const LandingSubtitle = styled('p')(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
  margin: 0,
  textAlign: 'center',
  maxWidth: '480px',
}));

export const TypingIndicator = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '4px',
  padding: '12px 16px',
  borderRadius: '12px',
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  alignSelf: 'flex-start',
  '& span': {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.text.secondary,
    animation: 'typing 1.4s infinite ease-in-out',
    '&:nth-of-type(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-of-type(3)': {
      animationDelay: '0.4s',
    },
  },
  '@keyframes typing': {
    '0%, 60%, 100%': {
      transform: 'translateY(0)',
      opacity: 0.4,
    },
    '30%': {
      transform: 'translateY(-4px)',
      opacity: 1,
    },
  },
}));

export const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});
